// Fix for non-passive event listener warnings (especially from third-party scripts like subscribe-it.js)
// This makes touchstart/touchmove/wheel events passive by default to improve scroll performance
// BUT excludes interactive elements like carousels, sliders, and video players that need preventDefault()
(function() {
  if (typeof EventTarget !== 'undefined') {
    let supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function() {
          supportsPassive = true;
        }
      });
      window.addEventListener('testPassive', null, opts);
      window.removeEventListener('testPassive', null, opts);
    } catch (e) {}

    if (supportsPassive) {
      const addEventListenerOriginal = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function(type, listener, options) {
        // Apply passive to touch and wheel events by default
        if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') {
          // Check if this element or its parents are interactive components that need preventDefault
          const element = this;
          const needsPreventDefault = element && (
            // Flickity carousels and sliders
            element.classList && (
              element.classList.contains('flickity-slider') ||
              element.classList.contains('flickity-viewport') ||
              element.classList.contains('carousel') ||
              element.classList.contains('slider') ||
              element.classList.contains('plyr') ||
              element.classList.contains('plyr__video-wrapper') ||
              element.classList.contains('plyr__controls') ||
              element.classList.contains('plyr__poster')
            ) ||
            // Check parent elements for Flickity, Plyr, or video players
            (element.closest && (
              element.closest('.flickity-enabled') ||
              element.closest('.flickity-slider') ||
              element.closest('[data-flickity]') ||
              element.closest('.carousel') ||
              element.closest('.plyr') ||
              element.closest('.plyr__video-wrapper') ||
              element.closest('.js-player') ||
              element.closest('.video-wrapper') ||
              element.closest('.quick-clips-carousel')
            ))
          );
          
          // Don't apply passive if element needs preventDefault()
          if (needsPreventDefault) {
            return addEventListenerOriginal.call(this, type, listener, options);
          }
          
          if (typeof options === 'object' && options !== null) {
            // Options object provided - only add passive if not already specified
            if (options.passive === undefined) {
              options.passive = true;
            }
          } else if (typeof options === 'boolean' || options === undefined) {
            // Boolean or undefined - convert to options object with passive
            const useCapture = options === true;
            options = {
              passive: true,
              capture: useCapture
            };
          }
        }
        return addEventListenerOriginal.call(this, type, listener, options);
      };
    }
  }
})();

// Shopify parseMoney polyfill
if (!window.Shopify.parseMoney) {
  window.Shopify.parseMoney = function(priceText) {
    if (!priceText) return null;
    var value = parseInt(priceText.replace(/[^0-9]/g, ''), 10);
    return !isNaN(value) ? value : null;
  };
}

// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }


//custom js

  let lastCleanupHadOrphaned = false;
  let cartUpdateInProgress = false;
  let bundleCleanupRunning = false;
  let lastCleanupTime = 0;
  const CLEANUP_DEBOUNCE_MS = 2000;

  function getBundleProp(props, key) {
    if (!props) return null;
    if (Object.prototype.hasOwnProperty.call(props, key)) return props[key];
    const underscoredKey = `_${key}`;
    if (Object.prototype.hasOwnProperty.call(props, underscoredKey)) return props[underscoredKey];
    return null;
  }

  function getBundleIdFromProps(props) {
    return getBundleProp(props, 'bundle_id');
  }

  function getBundleInstanceIdFromProps(props) {
    return getBundleProp(props, 'bundle_instance_id');
  }

  function isBundleBaseFromProps(props) {
    return String(getBundleProp(props, 'is_base') || '').toLowerCase() === 'true';
  }

  function getComponentRoleFromProps(props) {
    return getBundleProp(props, 'component_role');
  }

  function getCartItemAttr(cartItem, attrName) {
    if (!cartItem || !cartItem.$element || !cartItem.$element.length) return null;
    const value = cartItem.$element.attr(attrName);
    return value !== undefined ? value : null;
  }

  function getCartItemBundleInstanceId(cartItem) {
    return getCartItemAttr(cartItem, 'data-bundle-instance-id');
  }

  function getCartItemComponentRole(cartItem) {
    return getCartItemAttr(cartItem, 'data-component-role');
  }

  function isTruthyDataValue(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function getCartItemChoiceRequired(cartItem) {
    return getCartItemAttr(cartItem, 'data-choice-required');
  }

  function isRequiredRole(role) {
    return String(role || '').toLowerCase() === 'required';
  }

//mobile, move product info
function adjustPDPmobile() {
    if ($('#pdp-prod-gallery').length){
        if($('#header').is(':visible')) {
          const $priceTarget = $(".product-block--price").first();
          const $swatchTarget = $(".swatch_options").first();

          if ($priceTarget.length) {
            $("#pdp-prod-gallery").appendTo($priceTarget);
          }

          if ($swatchTarget.length) {
            const $modalPrices = $(".modal_price");
            const $primaryModalPrice = $modalPrices.first();
            $modalPrices.not($primaryModalPrice).remove();
            $primaryModalPrice.appendTo($swatchTarget);
          }
        }
    };
}
function adjustPDPdesktop() {
    if ($('#pdp-prod-gallery').length){
        if(!$('#header').is(':visible')) {

          //get video slider nav slider object and resize
        const flkty = Flickity.data('.carousel-nav');
      if(flkty) {
          flkty.resize();
      }


          const $imagesTarget = $(".product__images").first();
          const $formTarget = $(".product-block--form").first();

          if ($imagesTarget.length) {
            $("#pdp-prod-gallery").appendTo($imagesTarget);
          }

          if ($formTarget.length) {
            const $modalPrices = $(".modal_price");
            const $primaryModalPrice = $modalPrices.first();
            $modalPrices.not($primaryModalPrice).remove();
            $primaryModalPrice.prependTo($formTarget);
          }
        }
    };
}
adjustPDPmobile();


class Pushbar {
    constructor(config = { overlay: true, blur: false }) {
        this.activeId;
        this.activeElement;
        this.overlayElement;
        if (config.overlay) {
            this.overlayElement = document.createElement('div');
            this.overlayElement.classList.add('pushbar_overlay');
            document.querySelector('body').appendChild(this.overlayElement);
        }
        if (config.blur) {
            const mainContent = document.querySelector('.pushbar_main_content');
            if (mainContent) {
                mainContent.classList.add('pushbar_blur');
            }
        }
        this.bindEvents();
    }

    emitOpening() {
        const event = new CustomEvent('pushbar_opening', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    emitClosing() {
        const event = new CustomEvent('pushbar_closing', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    handleOpenEvent(e) {
        e.preventDefault();
        const pushbarId = e.currentTarget.getAttribute('data-pushbar-target');
        this.open(pushbarId);
    }

    handleCloseEvent(e) {
        e.preventDefault();
        this.close();
    }

    handleKeyEvent(e) {
        if (e.keyCode === 27) this.close();
    }

    bindEvents() {
        const triggers = document.querySelectorAll('[data-pushbar-target]');
        const closers = document.querySelectorAll('[data-pushbar-close]');
        triggers.forEach(trigger => trigger.addEventListener('click', e => this.handleOpenEvent(e), false));
        closers.forEach(closer => closer.addEventListener('click', e => this.handleCloseEvent(e), false));
        if (this.overlayElement) {
            this.overlayElement.addEventListener('click', e => this.handleCloseEvent(e), false);
        }
        document.addEventListener('keyup', e => this.handleKeyEvent(e));
    }

    open(pushbarId) {
        if (this.activeId === String(pushbarId) || !pushbarId) return;
        if (this.activeId && this.activeId !== String(pushbarId)) this.close();
        this.activeId = pushbarId
        this.activeElement = document.querySelector(`[data-pushbar-id="${this.activeId}"]`)
        if (!this.activeElement) return;
        this.emitOpening();
        this.activeElement.classList.add('opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.add('pushbar_locked');
        pageRootElement.setAttribute('pushbar', pushbarId)
    }

    close() {
        if (!this.activeId) return;
        this.emitClosing();
        this.activeElement.classList.remove('opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.remove('pushbar_locked');
        pageRootElement.removeAttribute('pushbar')
        this.activeId = null;
        this.activeElement = null;
    }
}



      if ($('.promo_banner').length){
        var promo_banner = Cookies.get('promo_banner');
       // console.dir(promo_banner);
        if (promo_banner != 'dismiss') {
          $('body').addClass('promo_banner-show');
          $('.promo_banner').on('click', '.promo_banner-close', function(){
            $('body').removeClass('promo_banner-show');
            Cookies.set('promo_banner', 'dismiss', { expires: 30 });
          });
        }
      }


  if ($('.banner_carousel').length){

  		// show
  		var $banner_carousel = $('.banner_carousel').removeClass('is-hidden');
  		// trigger redraw for transition
  		$banner_carousel[0].offsetHeight;

  		var $banner_carousel = $('.banner_carousel');

        $banner_carousel.flickity({
  		  // options
  		  cellAlign: 'center',
  		  contain: true,
  		  wrapAround: false,
  		  adaptiveHeight: false,
  		  pageDots: false,
  		  draggable: false,
  		  prevNextButtons: false,
  		  autoPlay: 3000,
  		  fade: true,
  		  pauseAutoPlayOnHover: false
  		});

  		$banner_carousel.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
  		//console.dir('click');
  		    $banner_carousel.flickity('playPlayer');

  		});




  		  const pushbar = new Pushbar({
  		        blur:true,
  		        overlay:true
  		      });




   }


   ////////////
   // Plugin //
   ////////////
(function($) {
   $.fn.headroom = function(option) {
     return this.each(function() {
       var $this   = $(this),
         data      = $this.data('headroom'),
         options   = typeof option === 'object' && option;

       options = $.extend(true, {}, Headroom.options, options);

       if (!data) {
         data = new Headroom(this, options);
         data.init();
         $this.data('headroom', data);
       }
       if (typeof option === 'string') {
         data[option]();

         if(option === 'destroy'){
           $this.removeData('headroom');
         }
       }
     });
   };

   //////////////
   // Data API //
   //////////////

   $('[data-headroom]').each(function() {
     var $this = $(this);
     $this.headroom($this.data());
   });

   }(window.Zepto || window.jQuery));


 //   $("header .header").headroom({
 //   "offset": 205,
 //   "tolerance": 5
 //
 // });

//product sticky header
if ($('#product-subnav').length){

  //mobile sticky header toggle dropdown
  /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */

  $('.dropbtn, #subnav_identifier').click(function(e){
      document.getElementById("myDropdown").classList.toggle("show");

      var dropbtn = document.getElementsByClassName("dropbtn");
      for (var i = 0; i < dropbtn.length; i++) {
  dropbtn[i].classList.toggle("open")
}
  });

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("prod-subnav-items");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {

        // setTimeout(function() {
        //   openDropdown.classList.remove('show');
        // }, 800);
      }
    }
  }
}
//end mobile


        //  $(".product-subnav.header").headroom({
        //  "offset": 205,
        //  "tolerance": 5
        //
        // });

        // Cache selectors
        var lastId,
         topMenu = $("#product-subnav"),
         topMenuHeight = topMenu.outerHeight()+1,
         // All list items
         menuItems = topMenu.find("a.nosmoothscroll:not(.button)"),
         // Anchors corresponding to menu items
         scrollItems = menuItems.map(function(){
           var item = $($(this).attr("href"));
            if (item.length) { return item; }


         });



        // Bind click handler to menu items
        // so we can get a fancy scroll animation
        menuItems.click(function(e){
          var href = $(this).attr("href"),
              offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
          $('html, body').stop().animate({
              scrollTop: offsetTop
          }, 850, function() {
            var dropdowns = document.getElementsByClassName("prod-subnav-items");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
              var openDropdown = dropdowns[i];
              if (openDropdown.classList.contains('show')) {

                setTimeout(function() {
                  openDropdown.classList.remove('show');
                }, 100);
              }
            }
});
          e.preventDefault();
        });

      // Bind to scroll - throttled for mobile performance
      var subnavScrollThrottle;
      $(window).scroll(function(){
         if (subnavScrollThrottle) {
           clearTimeout(subnavScrollThrottle);
         }
         subnavScrollThrottle = setTimeout(function() {
           // Get container scroll position
           var fromTop = $(window).scrollTop()+topMenuHeight;

           // Get id of current scroll item
           var cur = scrollItems.map(function(){
             if ($(this).offset().top < fromTop)
               return this;
           });
           // Get the id of the current element
           cur = cur[cur.length-1];
           var id = cur && cur.length ? cur[0].id : "";


           if (lastId !== id) {
             lastId = id;
             // Set/remove active class
             menuItems.parent().removeClass("active");
             var menuItemText =  $('.prod-subnav-items a[href="#'+id+'"]').text();
             if(menuItemText != '') {
               $('#subnav_identifier').text(menuItemText);
             }
             $('.prod-subnav-items a[href="#'+id+'"]').parent().addClass("active");
           }
         }, 100);
      });

};

//back to top_


  var offset = 300;
  var duration = 500;
  
  // Throttle scroll event to improve performance on mobile
  var backToTopThrottle;
  $(window).scroll(function() {
    if (backToTopThrottle) {
      clearTimeout(backToTopThrottle);
    }
    backToTopThrottle = setTimeout(function() {
      if ($(window).scrollTop() > offset) {
        $('.back-to-top').fadeIn(duration);
      }
      else {
        $('.back-to-top').fadeOut(duration);
      }
    }, 100);
  });
  
  $('.back-to-top').unbind('click.smoothscroll').bind('click', function(e) {
    e.preventDefault();
    $('html, body').animate( { scrollTop: 0 }, duration);
    return false;
  })


//smooth anchor scroll
var $root = $('html, body');

$('a[href^="#"]:not(.nosmoothscroll)').click(function() {
    var href = $.attr(this, 'href');
    
    // Ignore empty anchors or just "#"
    if (!href || href === '#' || href === '#/') {
      return true;
    }
    
    // Try to find anchor by name or id
    var aTag = $("a[name='"+ href +"']");
    if (!aTag.length) {
      try {
        aTag = $(href); // Try by ID selector
      } catch(e) {
        // Invalid selector, let browser handle it
        return true;
      }
    }
    
    // Only animate if target element exists
    if (aTag.length && aTag.offset()) {
      $('html,body').animate({scrollTop: aTag.offset().top}, {
            duration: 300,
            easing: "linear"
        } );
      return false;
    }
    
    // Let browser handle default anchor behavior if element not found
    return true;
});

if ($('#quick_clips_section .js-player').length){
  // Quick Clips: Show poster images, only load video on click
  // Same approach as mobile - prevents crashes from loading multiple videos
  const quickClipsPlayersCache = {};
  
  $('#quick_clips_section .js-player').each(function() {
    const $playerDiv = $(this);
    const videoID = $playerDiv.attr('data-plyr-embed-id');
    const playerDivID = $playerDiv.attr('id');
    
    // Create poster image with play button overlay
    const posterURL = `https://i.ytimg.com/vi/${videoID}/maxresdefault.jpg`;
    const $poster = $(`
      <div class="quick-clips-video-poster" data-video-id="${videoID}" data-player-div-id="${playerDivID}" style="position: relative; cursor: pointer; background: #000; height: 100%;">
        <img src="${posterURL}" alt="Video thumbnail" style="width: 100%; height: 100%; object-fit: cover; display: block;">
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 60px; height: 60px; background: rgba(0,0,0,0.7); border-radius: 50%; display: flex; align-items: center; justify-content: center;">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
      </div>
    `);
    
    // Replace player div with poster
    $playerDiv.replaceWith($poster);
  });
  
  // Click handler: Initialize and play video only when clicked
  $('body').on('click', '.quick-clips-video-poster', function() {
    const $poster = $(this);
    const videoID = $poster.data('video-id');
    const playerDivID = $poster.data('player-div-id');
    
    // Stop any currently playing videos in the Quick Clips carousel
    Object.keys(quickClipsPlayersCache).forEach(function(cachedID) {
      if (quickClipsPlayersCache[cachedID] && cachedID !== playerDivID) {
        try {
          quickClipsPlayersCache[cachedID].pause();
        } catch(e) {
          // Player might be destroyed, ignore
        }
      }
    });
    
    // Create the player div again
    const $playerDiv = $(`
      <div class="js-player" id="${playerDivID}" 
           data-plyr-provider="youtube" 
           data-plyr-embed-id="${videoID}">
      </div>
    `);
    
    // Replace poster with player div
    $poster.replaceWith($playerDiv);
    
    // Clean up old player instance if it exists (since DOM element was replaced)
    if (quickClipsPlayersCache[playerDivID]) {
      try {
        quickClipsPlayersCache[playerDivID].destroy();
      } catch(e) {
        // Ignore if already destroyed
      }
    }
    
    // Always create a new player instance for the new DOM element
    const player = new Plyr($playerDiv[0], { 
      volume: 0.5,
      autoplay: true
    });
    
    player.on('enterfullscreen', function(event) {
      $('.quick-clips-carousel').addClass('isFullscreen');
    });
    
    quickClipsPlayersCache[playerDivID] = player;
    player.play();
  });
}

  
// vimeo product video slider
if ($('.video-carousel-with-nav').length) {

  // Track initialized players by video ID to prevent memory leaks
  const videoPlayersCache = {};
  
  // Helper function to get or create a Plyr player instance
  function getOrCreatePlayer(vidID, element) {
    if (!vidID) return null;
    
    if (!videoPlayersCache[vidID]) {
      // Create new player only if it doesn't exist
      videoPlayersCache[vidID] = new Plyr(element, { 
        autoplay: true, 
        volume: 0.5 
      });
    }
    return videoPlayersCache[vidID];
  }

  // Mobile: Show poster images, only load video on click
  // This prevents ANY videos from initializing until user explicitly clicks
  if ($('.mobile_video_list .js-player').length) {
    $('.mobile_video_list .js-player').each(function() {
      const $playerDiv = $(this);
      const videoID = $playerDiv.attr('data-plyr-embed-id');
      const playerDivID = $playerDiv.attr('id');
      
      // Create poster image with play button overlay
      const posterURL = `https://i.ytimg.com/vi/${videoID}/maxresdefault.jpg`;
      const $poster = $(`
        <div class="mobile-video-poster" data-video-id="${videoID}" data-player-div-id="${playerDivID}" style="position: relative; cursor: pointer; background: #000;">
          <img src="${posterURL}" alt="Video thumbnail" style="width: 100%; display: block;">
          <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 80px; height: 80px; background: rgba(0,0,0,0.7); border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        </div>
      `);
      
      // Replace player div with poster
      $playerDiv.replaceWith($poster);
    });
    
    // Click handler: Initialize and play video only when clicked
    $('body').on('click', '.mobile-video-poster', function() {
      const $poster = $(this);
      const videoID = $poster.data('video-id');
      const playerDivID = $poster.data('player-div-id');
      
      // Create the player div again
      const $playerDiv = $(`
        <div class="js-player" id="${playerDivID}" 
             data-plyr-provider="youtube" 
             data-plyr-embed-id="${videoID}">
        </div>
      `);
      
      // Replace poster with player div
      $poster.replaceWith($playerDiv);
      
      // Initialize Plyr and autoplay
      if (!videoPlayersCache[playerDivID]) {
        const player = new Plyr($playerDiv[0], { 
          volume: 0.5,
          autoplay: true
        });
        videoPlayersCache[playerDivID] = player;
        player.play();
      }
    });
  }

  // cache your language selector
  var $langSelect   = $('#video-language-switcher');

  // cache main & nav carousels and their Flickity instances
  var $carousel     = $('.video-carousel-with-nav .carousel-main-video');
  var $navCarousel  = $('.video-carousel-with-nav .carousel-nav');
  var mainFlickity  = $carousel.data('flickity');
  var navFlickity   = $navCarousel.data('flickity');

  function filterByLanguage(lang) {
    var language = lang || 'English';

    // list items
    $('#videos_section .video_list_item').each(function(){
      var itemLang = $(this).attr('data-language')||'';
      var show = language==='English'
        ? (itemLang===''||itemLang==='English')
        : (itemLang===language);
      $(this)[ show ? 'show' : 'hide' ]();
    });

    // main slides
    $('.carousel-main-video .carousel-cell').each(function(){
      var itemLang = $(this).attr('data-language')||'';
      var show = language==='English'
        ? (itemLang===''||itemLang==='English')
        : (itemLang===language);
      $(this)[ show ? 'show' : 'hide' ]();
    });

    // nav slides
    $('.carousel-nav .carousel-cell').each(function(){
      var itemLang = $(this).attr('data-language')||'';
      var show = language==='English'
        ? (itemLang===''||itemLang==='English')
        : (itemLang===language);
      $(this)[ show ? 'show' : 'hide' ]();
    });

    // relayout main as before
    if ($carousel && mainFlickity) {
      $carousel.flickity('resize');
      var $first = $carousel.find('.carousel-cell:visible').first();
      if ($first.length) {
        $carousel.flickity('select', $first.index());
      }
    }

    // ── NEW: Reflow the **nav** carousel (no gaps) ──
    if (navFlickity) {
      navFlickity.reloadCells();    // re-scan cells
      navFlickity.resize();         // recalc sizes & positions
      // optional: jump nav to match main's initial cell
      var mainIndex = $carousel.data('flickity').selectedIndex;
      navFlickity.select(mainIndex);
    }
  }

  // init & hook change
  filterByLanguage($langSelect.val());
  $langSelect.on('change', function(){
    filterByLanguage(this.value);
  });

  // rest of your working code…
  var stopAllYouTubeVideos = () => {
    document.querySelectorAll('iframe').forEach(iframe => {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event:'command', func:'pauseVideo' }), '*'
      );
    });
  };
  function hideVidText() {
    $(".carousel-main-video .video__text-wrapper").fadeOut();
    $(".carousel-main-video .carousel-cell img").fadeOut();
  }
  $(".carousel-main-video a[data-play-button-video-id], #videos_section .carousel-nav .flickity-slider > div:first-of-type")
    .on("click", function(){
      stopAllYouTubeVideos();
      hideVidText();
      var vidID   = $('.carousel-main-video a[data-play-button-video-id]').data('play-button-video-id');
      var vidFrame = $(".carousel-main-video").find(`[data-video-id='${vidID}']`);
      
      // Lazy load: Create player only on first click, reuse existing player
      if (vidFrame.length) {
        var player = getOrCreatePlayer(vidID, vidFrame[0]);
        if (player) {
          player.play();
        }
      }
    });
  if ($carousel.length) {
    var selectedIndex = mainFlickity.selectedIndex;
    $carousel.on('select.flickity', function() {
      var isSame   = selectedIndex === mainFlickity.selectedIndex;
      var isPlaying = mainFlickity.player && mainFlickity.player.state === 'playing';
      if (isSame || isPlaying) return;
      selectedIndex = mainFlickity.selectedIndex;
      stopAllYouTubeVideos();
      hideVidText();
      var vidID    = $(mainFlickity.selectedElement).find('.youtube-iframe-container').data('video-id');
      var vidFrame = $(".carousel-main-video").find(`[data-video-id='${vidID}']`);
      
      // Lazy load: Create player only on first slide change, reuse existing player
      if (vidFrame.length) {
        var player = getOrCreatePlayer(vidID, vidFrame[0]);
        if (player) {
          player.play();
        }
      }
    });
  }

} // end .video-carousel-with-nav


	/* Toggle Video Modal
  -----------------------------------------*/
  if( $(".js-trigger-video-modal").length ) {
	function toggle_video_modal() {
    console.dir('js-trigger-video-modal');
	    // Click on video thumbnail or link
	    $(".js-trigger-video-modal").on("click", function(e){

          // prevent default behavior for a-tags, button tags, etc.
	        e.preventDefault();

          // Grab the video ID from the element clicked
          var id = $(this).attr('data-youtube-id');

          // Autoplay when the modal appears
          // Note: this is intetnionally disabled on most mobile devices
          // If critical on mobile, then some alternate method is needed
          var autoplay = '?autoplay=1';

          // Don't show the 'Related Videos' view when the video ends
          var related_no = '&rel=0';

          // String the ID and param variables together
          var src = '//www.youtube.com/embed/'+id+autoplay+related_no;

          // Pass the YouTube video ID into the iframe template...
          // Set the source on the iframe to match the video ID
          $("#youtube").attr('src', src);

          // Add class to the body to visually reveal the modal
          $("body").addClass("show-video-modal noscroll");

      });

	    // Close and Reset the Video Modal
      function close_video_modal() {

        event.preventDefault();

        // re-hide the video modal
        $("body").removeClass("show-video-modal noscroll");

        // reset the source attribute for the iframe template, kills the video
        $("#youtube").attr('src', '');

      }
      // if the 'close' button/element, or the overlay are clicked
	    $('body').on('click', '.close-video-modal, .video-modal .overlay', function(event) {

          // call the close and reset function
          close_video_modal();

      });
      // if the ESC key is tapped
      $('body').keyup(function(e) {
          // ESC key maps to keycode `27`
          if (e.keyCode == 27) {

            // call the close and reset function
            close_video_modal();

          }
      });
	}
	toggle_video_modal();

};

//end video modal product page



      //header for pages

        if ($('.move-header').length){
        	$('.move-header').appendTo( ".mega-menu-container" );

      }



/*========
back to top
========*/
    // $(window).scroll(function(){
    //     if ($(this).scrollTop() > 100) {
    //         $('#scroll').fadeIn();
    //     } else {
    //         $('#scroll').fadeOut();
    //     }
    // });
    // $('#scroll').click(function(){
    //     $("html, body").animate({ scrollTop: 0 }, 600);
    //     return false;
    // });


/*======
more info on pdp
======*/
if($('#read_more').length){
 $('#read_more').click(function(){

 		if( ! $('.product-template .description').hasClass('has-read-more')           ) {
 			 $('.product-template .description').addClass('has-read-more');

 	}

        var link = $(this);
        $('#read_more_container').slideToggle('fast', function() {
            if ($(this).is(":visible")) {
                 link.text('Close >');
                 link.addClass('close');


            } else {
            	 $('.product-template .description').removeClass('has-read-more');
                 link.text('Read More >');
                 link.removeClass('close');

                 $('html,body').animate({
                    scrollTop:  $("#overview").offset().top
                 });
            }
        });

    });
}


      $('.footer_menu a').each(function() {
 var a = new RegExp('/' + window.location.host + '/');
 if (!a.test(this.href)) {
    $(this).attr("target","_blank");
 }
});




//end custom js


  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    adjustPDPmobile();

    adjustPDPdesktop();
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
          console.dir(currentScreenWidth);

        }

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length && !$iframe.hasClass('nolazyload')) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length && $iframe.hasClass('nolazyload')) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature_divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace('*', ''));
  }

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');

  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  // Prevent zoom on input focus for iOS, but check if value needs changing to avoid reload loops
  // DISABLED: This was causing crashes on iPhone by constantly manipulating viewport
  // $('input, select, textarea').on('focus blur', event => {
  //   const $viewport = $('meta[name=viewport]');
  //   const newContent = `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`;
  //   
  //   // Only update if the content is actually different
  //   if ($viewport.attr('content') !== newContent) {
  //     $viewport.attr('content', newContent);
  //   }
  // });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset().top),
    }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  $('body').on('mouseenter', '.icon-search', () => {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', () => {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', e => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordionCustom('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning }</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });

    // Cleanup orphaned bundles when mini-cart drawer opens (only if not navigating to checkout)
    $('body').on('click', '.cart-container, .mini_cart, .icon-cart', function() {
      setTimeout(() => {
        if ($('.cart_content').is(':visible')) {
          cleanupOrphanedBundles();
        }
      }, 100);
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function updateCartItemQuantity(cartItem) {
    cartUpdateInProgress = true;
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        }

        const removedBaseBundle = removeBundleIfBaseRemoved(data, cartItem);
        if (removedBaseBundle) {
          cartUpdateInProgress = false;
          return;
        }

        const removedRequiredBundle = removeBundleIfRequiredRemoved(data, cartItem);
        if (removedRequiredBundle) {
          cartUpdateInProgress = false;
          return;
        }
        const isCartTemplate = cartItem.parentCartForm.data('cart-form') === 'cart-template';
        const needsBundleCleanup = getBundleItemsMissingBase(data).length > 0;

        // If a bundle base was removed, also remove associated components
        if (needsBundleCleanup) {
          removeBundleComponentsWithoutBase(data, cartItem, {
            skipRefresh: isCartTemplate,
            onComplete: (_removed, updatedCart) => {
              if (!isCartTemplate) {
                refreshCart(updatedCart || data);
              }
            },
          });
        } else if (isCartTemplate) {
          window.location.reload();
        } else {
          refreshCart(data);
        }
        cartUpdateInProgress = false;
      },
      error() {
        cartUpdateInProgress = false;
      },
    });
  }

  function getBundleItemsMissingBase(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    const bundles = {};

    cart.items.forEach((item, idx) => {
      const props = item.properties || {};
      const bundleInstanceId = getBundleInstanceIdFromProps(props);
      if (!bundleInstanceId) return;

      const isBase = isBundleBaseFromProps(props);
      const lineNumber = idx + 1;
      const key = item.key;

      if (!bundles[bundleInstanceId]) {
        bundles[bundleInstanceId] = { hasBase: false, items: [] };
      }

      bundles[bundleInstanceId].items.push({ line: lineNumber, key, bundleInstanceId, item });
      if (isBase) {
        bundles[bundleInstanceId].hasBase = true;
      }
    });

    const itemsToRemove = [];
    Object.keys(bundles).forEach(bundleInstanceId => {
      const bundleGroup = bundles[bundleInstanceId];
      if (bundleGroup.hasBase) return;
      itemsToRemove.push(...bundleGroup.items);
    });

    return itemsToRemove;
  }

  function getBundleIdsMissingBase(cart) {
    const bundles = getBundleItemsMissingBase(cart).reduce((set, entry) => {
      set.add(entry.bundleInstanceId);
      return set;
    }, new Set());
    return Array.from(bundles);
  }

  function cleanupOrphanedBundles(force = false) {
    const now = Date.now();

    if (window.location.pathname.includes('/checkout') || window.location.pathname.includes('/cart/checkout')) {
      return;
    }

    if (!force && cartUpdateInProgress) {
      return;
    }

    if (now - lastCleanupTime < CLEANUP_DEBOUNCE_MS) {
      return;
    }

    if (!force && !lastCleanupHadOrphaned && (now - lastCleanupTime < CLEANUP_DEBOUNCE_MS * 2)) {
      return;
    }

    lastCleanupTime = now;

    if (bundleCleanupRunning) {
      return;
    }
    bundleCleanupRunning = true;

    (async () => {
      try {
        const removed = [];
        const failed = [];

        let liveCart;
        try {
          const fetchPromise = fetch('/cart.js', { credentials: 'same-origin' });
          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Fetch timeout')), 5000)
          );

          const response = await Promise.race([fetchPromise, timeoutPromise]);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          liveCart = await response.json();
        } catch (err) {
          if (err.message !== 'Fetch timeout' && document.visibilityState === 'visible') {
            console.error('Bundle cleanup: failed to fetch cart', err);
          }
          bundleCleanupRunning = false;
          return;
        }

        const bundlesMissingBase = getBundleIdsMissingBase(liveCart);
        const isCartPageCheck = $('body').hasClass('cart');

        if (!bundlesMissingBase.length) {
          lastCleanupHadOrphaned = false;
          if (isCartPageCheck && force) {
            window.location.reload();
          }
          return;
        }
        lastCleanupHadOrphaned = true;

        const itemsToRemove = getBundleItemsMissingBase(liveCart);
        if (itemsToRemove.length === 0) {
          return;
        }

        let finalCart = liveCart;

        for (let i = 0; i < itemsToRemove.length; i++) {
          const item = itemsToRemove[i];
          try {
            const payload = item.key
              ? { id: item.key, quantity: 0 }
              : { line: item.line, quantity: 0 };

            const changeResponse = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify(payload)
            });

            if (!changeResponse.ok) {
              const errorText = await changeResponse.text();
              failed.push({ item, error: `HTTP ${changeResponse.status}: ${errorText}` });
              continue;
            }

            const changeData = await changeResponse.json();

            if (changeData && changeData.errors) {
              failed.push({ item, error: changeData.errors });
            } else {
              removed.push(item);
              if (changeData && changeData.items) {
                finalCart = changeData;
              }

              if (i < itemsToRemove.length - 1) {
                await new Promise(resolve => setTimeout(resolve, 200));
              }
            }
          } catch (err) {
            console.error('Bundle cleanup: Failed to remove item', item, err);
            failed.push({ item, error: err });
          }
        }

        if (removed.length > 0) {
          try {
            const fetchPromise = fetch('/cart.js', { credentials: 'same-origin' });
            const timeoutPromise = new Promise((_, reject) =>
              setTimeout(() => reject(new Error('Fetch timeout')), 5000)
            );

            const response = await Promise.race([fetchPromise, timeoutPromise]);
            if (response.ok) {
              finalCart = await response.json();
            }
          } catch (err) {
            console.warn('Bundle cleanup: Could not fetch final cart, using last known state', err);
          }
        }

        if (isCartPageCheck) {
          window.location.reload();
        } else if (finalCart) {
          refreshCart(finalCart);
        }

        if (failed.length) {
          console.error('Bundle cleanup: some items could not be removed', failed);
        }
      } catch (err) {
        console.error('Bundle cleanup: unexpected error', err);
      } finally {
        bundleCleanupRunning = false;
      }
    })();
  }

  function removeBundleComponentsWithoutBase(cart, cartItem, options = {}) {
    const orphanedBundles = getBundleIdsMissingBase(cart);
    if (orphanedBundles.length > 0) {
      cleanupOrphanedBundles(true);
    }
    if (options.onComplete) {
      setTimeout(() => {
        const fetchPromise = fetch('/cart.js', { credentials: 'same-origin' });
        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Fetch timeout')), 5000)
        );

        Promise.race([fetchPromise, timeoutPromise])
          .then(r => {
            if (!r.ok) {
              throw new Error(`HTTP ${r.status}: ${r.statusText}`);
            }
            return r.json();
          })
          .then(updatedCart => options.onComplete(true, updatedCart))
          .catch(() => {
            options.onComplete(false, cart);
          });
      }, 500);
    }
  }

  function removeBundleItemsByInstanceId(cart, bundleInstanceId, cartItem) {
    if (!bundleInstanceId || bundleCleanupRunning) return false;
    if (!cart || !Array.isArray(cart.items)) return false;

    const itemsToRemove = cart.items
      .map((item, index) => ({
        item,
        key: item.key,
        line: index + 1,
        bundleInstanceId: getBundleInstanceIdFromProps(item.properties || {})
      }))
      .filter(entry => entry.bundleInstanceId && String(entry.bundleInstanceId) === String(bundleInstanceId));

    if (!itemsToRemove.length) return false;

    bundleCleanupRunning = true;
    const isCartTemplate = cartItem && cartItem.parentCartForm
      ? cartItem.parentCartForm.data('cart-form') === 'cart-template'
      : false;

    (async () => {
      try {
        for (let i = 0; i < itemsToRemove.length; i++) {
          const entry = itemsToRemove[i];
          const payload = entry.key ? { id: entry.key, quantity: 0 } : { line: entry.line, quantity: 0 };
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'same-origin',
          });
        }

        const updatedCartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
        const updatedCart = updatedCartResponse.ok ? await updatedCartResponse.json() : cart;

        if (isCartTemplate) {
          window.location.reload();
        } else {
          refreshCart(updatedCart);
        }
      } catch (error) {
        console.error('Bundle required removal: failed to remove items', error);
      } finally {
        bundleCleanupRunning = false;
      }
    })();

    return true;
  }

  function removeBundleIfRequiredRemoved(cart, cartItem) {
    if (!cart || !Array.isArray(cart.items) || !cartItem || Number(cartItem.quantity) !== 0) return false;

    const bundleInstanceId = getCartItemBundleInstanceId(cartItem);
    if (!bundleInstanceId) return false;

    const componentRole = getCartItemComponentRole(cartItem);
    const choiceRequired = getCartItemChoiceRequired(cartItem);
    if (!isRequiredRole(componentRole) && !isTruthyDataValue(choiceRequired)) return false;

    return removeBundleItemsByInstanceId(cart, bundleInstanceId, cartItem);
  }

  function removeBundleIfBaseRemoved(cart, cartItem) {
    if (!cart || !Array.isArray(cart.items) || !cartItem || Number(cartItem.quantity) !== 0) return false;

    const bundleInstanceId = getCartItemBundleInstanceId(cartItem);
    if (!bundleInstanceId) return false;

    const isBase = isTruthyDataValue(getCartItemAttr(cartItem, 'data-is-base'));
    if (!isBase) return false;

    return removeBundleItemsByInstanceId(cart, bundleInstanceId, cartItem);
  }

  function refreshCartID () {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    let cartItemsHTML = "";
    let cartDiscountsHTML = "";
    let cartActionHTML = "";
    let cartSavingsHTML = "";
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    let bundleBaseCount = 0;
    let nonBundleCount = 0;
    cart.items.forEach(item => {
      const instanceId = getBundleInstanceIdFromProps(item.properties);
      if (instanceId) {
        const isBase = String(getBundleProp(item.properties, 'is_base') || '').toLowerCase() === 'true';
        if (isBase) {
          bundleBaseCount += 1;
        }
      } else {
        nonBundleCount += item.quantity;
      }
    });
    const displayCount = nonBundleCount + bundleBaseCount;
    $cartBtn.text(displayCount);

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      const bundleInstances = {};
      cart.items.forEach((item, index) => {
        const instanceId = getBundleInstanceIdFromProps(item.properties);
        if (!instanceId) return;
        if (!bundleInstances[instanceId]) {
          bundleInstances[instanceId] = { items: [], baseItem: null, total: 0 };
        }
        const entry = { item, lineID: index + 1 };
        bundleInstances[instanceId].items.push(entry);
        bundleInstances[instanceId].total += item.final_line_price;
        if (String(getBundleProp(item.properties, 'is_base') || '').toLowerCase() === 'true') {
          bundleInstances[instanceId].baseItem = entry;
        }
      });

      function getMiniCartComponentLabel(bundleItem) {
        if (!bundleItem) return '';
        const props = bundleItem.properties || {};
        if (String(props._bundle_hidden_component || '').toLowerCase() === 'true') {
          return '';
        }
        const displayTitle = props._component_display_title || bundleItem.product_title || bundleItem.title || '';
        const variantTitle = bundleItem.variant_title;
        if (variantTitle && variantTitle !== 'Default Title' && variantTitle !== displayTitle) {
          return `${displayTitle} - ${variantTitle}`;
        }
        return displayTitle;
      }

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        const bundleInstanceId = getBundleInstanceIdFromProps(item.properties);
        const componentRole = getComponentRoleFromProps(item.properties);
        const isBase = getBundleProp(item.properties, 'is_base');
        const choiceRequired = getBundleProp(item.properties, 'is_choice_required');
        const bundleAttrs = bundleInstanceId
          ? ` data-bundle-instance-id="${bundleInstanceId}" data-component-role="${componentRole || ''}" data-is-base="${isBase || ''}" data-choice-required="${choiceRequired || ''}"`
          : '';

        if (bundleInstanceId && String(isBase || '').toLowerCase() !== 'true') {
          return true;
        }

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}"${bundleAttrs}>`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        const baseTitle = item.product_title || item.title || '';
        let variantSuffix = '';
        const bundleDisplayColor = item.properties ? item.properties._bundle_display_color : null;
        const bundleDisplaySize = item.properties ? item.properties._bundle_display_size : null;
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantSuffix = ` - ${item.variant_title}`;
        }
        if (bundleDisplayColor || bundleDisplaySize) {
          const customParts = [];
          if (bundleDisplayColor) {
            customParts.push(`Color: ${bundleDisplayColor}`);
          }
          if (bundleDisplaySize) {
            customParts.push(`Size: ${bundleDisplaySize}`);
          }
          if (customParts.length) {
            variantSuffix = ` - ${customParts.join(' / ')}`;
          }
        }
        if (bundleInstanceId && bundleInstances[bundleInstanceId]) {
          const componentLabels = bundleInstances[bundleInstanceId].items
            .filter(entry => entry.item && entry.item !== item)
            .filter(entry => String(((entry.item || {}).properties || {})._bundle_hidden_component || '').toLowerCase() !== 'true')
            .map(entry => getMiniCartComponentLabel(entry.item))
            .filter(label => label);
          if (componentLabels.length) {
            variantSuffix = `${variantSuffix} / ${componentLabels.join(' / ')}`;
          }
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${baseTitle}</a>${variantSuffix}`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (!value) return;
            if (title && String(title).charAt(0) === '_') return;
            cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
          });
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        if (bundleInstanceId && bundleInstances[bundleInstanceId]) {
          const bundleTotal = bundleInstances[bundleInstanceId].total;
          const itemPrice = window.Shopify.formatMoney(bundleTotal, $('body').data('money-format'));
          cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
        } else {
          $.ajax({
            dataType: 'json',
            async: false,  // WARNING: Synchronous AJAX is deprecated but needed here for cart refresh logic
            cache: true,   // Enable caching to reduce duplicate requests
            url: `/products/${item.handle}.js`,
            success(data) {
              let productData = data;
              // If item has more than one variant, need to make sure we are pulling data from the correct variant
              if (productData.variants) {
                const itemVariants = productData.variants;
                if (itemVariants.length > 1) {
                  for (let v = 0; v < itemVariants.length; v++) {
                    if (itemVariants[v].id === item.id) {
                      productData = itemVariants[v];
                    }
                  }
                }
              }

              // If compare at price exists then item is on sale
              if (productData.compare_at_price) {
                if (productData.compare_at_price > productData.price) {
                  productHasSale = true;
                  productCompareAtPrice = productData.compare_at_price;
                  productFinalPrice = productData.price;
                }
              } else {
                // Check required for non-sale items
                productHasSale = false;
              }
            },
          });

          if (productHasSale === true) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

            // Total savings
            saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
            totalSaving = saving + totalSaving;
          } else if (item.price > item.final_price) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
          } else {
            const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
            if (item.price > 0) {
              cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
            } else {
              cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
            }
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (!bundleInstanceId && item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (!bundleInstanceId && item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        if (!bundleInstanceId) {
          cartItemsHTML += '<div class="product-quantity-box">';
          cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
          cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
          cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
          cartItemsHTML += '</div>';
        }
        cartItemsHTML += '</div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof window.Shopify) window.Shopify={};window.Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},window.Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},window.Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},window.Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)window.Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},window.Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},window.Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},window.Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},window.Shopify.locationSearch=function(){return window.location.search},window.Shopify.locationHash=function(){return window.location.hash},window.Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},window.Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(window.Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},window.Shopify.newState=function(t,e){var o;return o=window.Shopify.urlParam(t)?window.Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===window.Shopify.locationSearch()?"?"+t+"="+e:window.Shopify.locationSearch()+"&"+t+"="+e,o+window.Shopify.locationHash()},window.Shopify.setParam=function(t,e){window.Shopify.replaceState(window.Shopify.newState(t,e))},window.Shopify.Product=function(t){window.Shopify.isDefined(t)&&this.update(t)},window.Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},window.Shopify.Product.prototype.optionNames=function(){return"Array"==window.Shopify.getClass(this.options)?this.options:[]},window.Shopify.Product.prototype.optionValues=function(t){if(!window.Shopify.isDefined(this.variants))return null;var e=window.Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:window.Shopify.uniq(e)},window.Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(window.Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},window.Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},window.Shopify.money_format="$",window.Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2,"'",".");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},window.Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new window.Shopify.Product(e.product),this.onVariantSelected=window.Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new window.Shopify.OptionSelectors.HistoryState(this)),!0},window.Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},window.Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;window.Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},window.Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=window.Shopify.urlParam("variant");return this.selectVariant(e,t)},window.Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},window.Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},window.Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){window.Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);window.Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},window.Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new window.Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=window.Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},window.Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},window.Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},window.Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM,window.Shopify.OptionSelectors),window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!window.Shopify.isDefined(o))var o=!0;if(!window.Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];window.Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},window.Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},window.Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},window.Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},window.Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||window.Shopify.setParam("variant",t.id))},window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      sliderBlock.select(blockId, $parentSection);
    }
});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
});

$(document)
  .on('shopify:section:reorder', function(e){
    window.utils.initializeSectionWrapper();
});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete){
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }

});


$(document)
  .on('shopify:section:unload', function(e){
    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
});



$(function(){
  var $wrapper     = $('.custom-dropdown');
  var $toggle      = $wrapper.find('.custom-dropdown__toggle');
  var $list        = $wrapper.find('.custom-dropdown__list');
  var $options     = $list.find('li');
  var $selectedTxt = $wrapper.find('.custom-dropdown__selected');
  var $realSelect  = $('#video-language-switcher');

  // open/close (and hide the current choice)
  $toggle.on('click', function(){
    var current = $realSelect.val();
    // show all, then hide the one matching current
    $options.show().filter('[data-value="'+ current +'"]').hide();
    $wrapper.toggleClass('open');
  });

  // pick an option
  $options.on('click', function(){
    var $li    = $(this);
    var value  = $li.data('value');
    var label  = $li.text();

    // update UI
    $options.removeClass('is-selected').show();
    $li.addClass('is-selected').hide(); // hide it now that it's chosen
    $selectedTxt.text(label);

    // close
    $wrapper.removeClass('open');

    // sync real select & trigger filter
    $realSelect.val(value).trigger('change');
  });

  // click outside closes
  $(document).on('click', function(e){
    if ($wrapper.length && $wrapper[0] && !$.contains($wrapper[0], e.target)) {
      $wrapper.removeClass('open');
    }
  });
});

